const MuiSelect = {
    selectMenu: {
      height: null,
    },
  }
  
  export default MuiSelect
  